import useDdw from "./useDdw";

export const roostertjes = {
  useDdw,
};
